import styles from "./home.module.css"
import TEDxHero from "./TedxHero";

import TEDxShipOfTheseus from "./theme";

import TedxFriendshipFiesta from "./TedxFriendshipFiesta";

import photo1 from "./assets/fsf-01.jpg";
import photo2 from "./assets/fsf-02.JPG";
import photo3 from "./assets/fsf-03.JPG";
import photo4 from "./assets/fsf-04.JPG";
import photo5 from "./assets/fsf-05.JPG";
import photo6 from "./assets/fsf-06.JPG";
import photo7 from "./assets/fsf-07.JPG";
import photo8 from "./assets/fsf-08.JPG";
import photo9 from "./assets/fsf-09.JPG";
import photo10 from "./assets/fsf-10.JPG";
import photo11 from "./assets/fsf-11.JPG";
import photo12 from "./assets/fsf-12.JPG";
// import ThankYouSlide from "../questionSubmission/ThankYouSlide";

const eventPhotos = [
  { src: photo1, alt: "Friendship Fiesta moment 01" },
  { src: photo2, alt: "Friendship Fiesta moment 02" },
  { src: photo3, alt: "Friendship Fiesta moment 03" },
  { src: photo4, alt: "Friendship Fiesta moment 04" },
  { src: photo5, alt: "Friendship Fiesta moment 05" },
  { src: photo6, alt: "Friendship Fiesta moment 06" },
  { src: photo7, alt: "Friendship Fiesta moment 07" },
  { src: photo8, alt: "Friendship Fiesta moment 08" },
  { src: photo9, alt: "Friendship Fiesta moment 09" },
  { src: photo10, alt: "Friendship Fiesta moment 10" },
  { src: photo11, alt: "Friendship Fiesta moment 11" },
  { src: photo12, alt: "Friendship Fiesta moment 12" },
];


const Homecompo = () => {
    return (
        <div>
            <TEDxShipOfTheseus></TEDxShipOfTheseus> 
           {/* <TEDxHero></TEDxHero> */}
            <TedxFriendshipFiesta photos={eventPhotos} />
           {/* <ThankYouSlide /> */}
           {/*<SpeakersSection />*/}
        </div>
    );
}

export default Homecompo;